import type { WaitTime } from ".prisma/client";

export function isWaitTimeStale(waitTime: WaitTime) {
    const oneHourAgo = new Date();
    oneHourAgo.setHours(oneHourAgo.getHours() - 1);
    const createdAtParsed = new Date(waitTime?.createdAt);

    const isWaitTimeStale = waitTime ? createdAtParsed < oneHourAgo : false;

    return isWaitTimeStale;
}